import Textarea from './textarea'

export const AmuiTextarea = Textarea

export default Vue => Vue.component(Textarea.name, Textarea)
